import { FocusTrap } from '@mui/base/FocusTrap';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

interface Props {
  children: React.ReactElement;
  onClose?: VoidFunction;
  size?: ModalSize;
  containerClassName?: string;
  panelWrapperClassName?: string;
}

export type ModalSize = 'compact' | 'default' | 'large' | 'full-page';

export const ModalContainer: React.FC<Props> = ({ children, onClose, size = 'default', containerClassName, panelWrapperClassName }) => (
  // Bypass z-index of the Header
  <div className={twMerge(clsx('z-modal fixed inset-0', containerClassName))}>
    <div className='fixed inset-0 bg-gray-900/50 transition-opacity' />

    <div className='z-modal fixed inset-0 overflow-y-auto'>
      <div
        className={twMerge(
          clsx(
            'flex min-h-screen items-center justify-center px-4 pt-4 pb-20 text-center lg:p-0',
            size === 'full-page' && 'h-full px-0 pt-0 pb-0 sm:h-auto sm:px-4 sm:pt-4 sm:pb-20',
            panelWrapperClassName,
          ),
        )}
        onClick={event => {
          if (onClose && event.target === event.currentTarget) {
            onClose();
          }
        }}>
        <FocusTrap open>{children}</FocusTrap>
      </div>
    </div>
  </div>
);
